import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyProductKey,
  ShopifySellingPlanGroupKey,
  ShopifySellingPlanGroupProductIdKey,
  ShopifySellingPlanGroupProductKey,
  ShopifySellingPlanGroupProductToProductKey,
  ShopifySellingPlanGroupProductToSellingPlanGroupKey,
  ShopifySellingPlanGroupProductToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifySellingPlanGroupProductKey,
  "2022-01": {
    name: "Shopify Selling Plan Group Product",
    fields: [
      {
        name: "ID",
        key: ShopifySellingPlanGroupProductIdKey,
        fieldType: FieldType.ID,
      },
      {
        name: "Selling Plan Group",
        fieldType: FieldType.BelongsTo,
        key: ShopifySellingPlanGroupProductToSellingPlanGroupKey,
        configuration: {
          relatedModelKey: ShopifySellingPlanGroupKey,
        },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifySellingPlanGroupProductToProductKey,
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifySellingPlanGroupProductToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // synced as part of ShopifySellingPlanGroup
    syncConfig: { type: "inherit" } as const,
  },
};

export const ShopifySellingPlanGroupProduct = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
